import { LPT3000RX4 } from './LPT3000RX4';
import { LPT3000R } from './LPT3000R';
import { ANRISTU_MS27103A } from './ANRISTU_MS27103A';
import { AnalyzerPropertyConstants } from 'types';
import { SED_DECIMATOR } from './SED_DECIMATOR';
import { RohdeSchwarz_FPS7 } from './RohdeSchwarz_FPS7';

const analyzerTypes = {
  0: LPT3000RX4,
  1: LPT3000R,
  3: ANRISTU_MS27103A,
  4: SED_DECIMATOR,
  5: RohdeSchwarz_FPS7,
};

export function getAnalyzerType(
  type: 0 | 1 | 3 | 4 | 5
): AnalyzerPropertyConstants {
  return analyzerTypes[type];
}

export function getAnalyzerTypeName(type: number | undefined) {
  switch (type) {
    case 0:
      return 'LPT-3000RX4';
    case 1:
      return 'LPT-3000R';
    case 3:
      return 'Anritsu MS27103A';
    case 4:
      return 'SED Decimator';
    case 5:
      return 'Rhode-Schwarz FPS7';
    default:
      return 'Other';
  }
}

export function getManufacturerFromType(type: number | undefined) {
  switch (type) {
    case 0:
      return 'LP Technologies';
    case 1:
      return 'LP Technologies';
    case 3:
      return 'Anritsu';
    case 4:
      return 'Decimator';
    case 5:
      return 'Rohde&Schwarz';
    default:
      return 'Other';
  }
}
